module.exports = __webpack_public_path__ + "1cf71bbcd1b93891ca126c0594d986e0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/stethescope.png
// module id = 2127
// module chunks = 0